import { format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

const TIMEZONE = 'Asia/Tokyo';

const formatDateTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date)) return '';
  const zonedDate = toZonedTime(date, TIMEZONE);
  return format(zonedDate, 'yyyy-MM-dd HH:mm');
};

const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date)) return '';
  const zonedDate = toZonedTime(date, TIMEZONE);
  return format(zonedDate, 'yyyy-MM-dd');
};

const formatCurrency = (
  value,
  currency = "JPY",
  locale = "ja-JP"
) => {
  if (value == null) return "";

  const formatted = new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).format(value);

  // 日本円だけは「￥」を除いて「 円」に
  if (currency === "JPY") {
    return formatted.replace("￥", "") + " 円";
  }

  return formatted;
};
const formatPaymentMonth = (offset) => {
  switch (Number(offset)) {
    case 0:
      return '当月';
    case 1:
      return '翌月';
    case 2:
      return '翌々月';
    default:
      return `${offset}ヶ月後`;
  }
};
export { formatDate, formatDateTime, formatCurrency, formatPaymentMonth };
